import { Box, Grid2 as Grid, Typography } from "@mui/material";
import { User } from "../../../../types/user.js";
import { OnboardingWidget } from "../../../../components/Advertiser/Widgets";

const AdminDashboard = ({ user }: { user: User }) => {
    return (
        <Box sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'left',
            gap: 3,
            margin: 3
        }}>
            <Box display="flex">
                <Typography variant="h5">Welcome, {user.businessName}</Typography>
            </Box>
            <Grid container spacing={2} width="100%" minWidth="800px">
                <OnboardingWidget type="admin" />
            </Grid>
        </Box>
    )
}

export default AdminDashboard;
